"use client";
import {
  ChartType,
  ChartTypeArray,
  DataElement,
  DataInputParams,
  DatePickerTypeArray,
  InputTypeValue,
} from "@/components/layout/input/inputType";
import * as DataInput from "@/components/layout/input";
import {
  checkDisplay,
  checkDisplayCommon,
  convertSubListToFormData,
  GetDataInputElement,
  getInputCommonParams,
  getInputFieldValue,
  getInputParams,
  getLabelInputName,
  getMultiValue,
  getSubListLabelField,
  getSubListValueField,
} from "../input/inputFunction";
import { DataList, Flex } from "@radix-ui/themes";
//import { Skeleton as AntSkeleton } from "antd";
import { useTranslations } from "next-intl";
import { Debug } from "@/util/debug";
import { cn } from "@/lib/utils";
import { JSX, useEffect, useMemo, useRef, useState } from "react";

import { Skeleton } from "@radix-ui/themes";
import { Skeleton as AntSkeleton } from "antd";
import { mergeToken } from "antd/es/theme/internal";
import { useFlexWrapDetect } from "@/app/hook/useFlexWrapDetect";

// import dynamic from "next/dynamic";
// const AntSkeletonInput = dynamic(() => import("antd").then((mod) => mod.Skeleton.Input), { ssr: false });
// const Skeleton = dynamic(() => import("@radix-ui/themes").then((mod) => mod.Skeleton), { ssr: false });

const getScale = (value: any, valueType: InputTypeValue, scale?: number) => {
  return scale != undefined && scale != null
    ? typeof value === "number"
      ? value / scale
      : valueType === "number" && value !== undefined && value !== null
        ? Number(value) / scale
        : value
    : value;
};
export function GetDataLabel(params: DataInputParams) {
  const [label, setLabel] = useState<string | JSX.Element | undefined>(undefined);
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setLabel"] = setLabel;
    }
  }
  const t = useTranslations(params.transitionGroup ?? "contents");
  const dataLabel: string | DataElement =
    params.label ?? (params.subListName ? params.subListName : (params.labelNamePrev ?? "") + params.name);
  const DataLabel: DataElement = typeof dataLabel === "string" ? { element: dataLabel } : dataLabel;
  const DataLabelElement = DataLabel.element;

  const subListLabelStr = getSubListLabelField(params);
  const subListLabelValue = subListLabelStr ? getInputFieldValue(params, subListLabelStr) : undefined;
  const subListlabel = subListLabelValue
    ? params.subList instanceof Object && params.subList.labelTransition
      ? t(subListLabelValue)
      : subListLabelValue
    : undefined;
  return (
    <>
      {label
        ? label
        : subListlabel !== undefined
          ? subListlabel
          : typeof dataLabel === "string"
            ? DataLabelElement === ""
              ? "    "
              : typeof DataLabelElement === "string" && (DataLabel.transition ?? params.labelTransition ?? true)
                ? params.index !== undefined
                  ? t(DataLabelElement, { value: params.index + 1 })
                  : t(DataLabelElement)
                : DataLabelElement
            : GetDataInputElement(DataLabel, false, null, t)}
    </>
  );
}
const GetDataType = (params: DataInputParams) => {
  //console.log(params.name);
  const value = getScale(params.value, params.valueType, params.scale);
  const defaultValue = getScale(params.defaultValue, params.valueType, params.scale);
  const rangeDefaultValue = getScale(params.defaultValue, params.valueType, params.scale);
  const rangeValue =
    params.rangeField && params.values[params.rangeField] != null ? getScale(params.value, params.valueType, params.scale) : undefined;

  const mergeParams = {
    ...params,
    value: value,
    defaultValue: defaultValue,
    rangeValue: rangeValue,
    rangeDefaultValue: rangeDefaultValue,
  };
  if ((params.dataInputMode ?? params.inputMode) === "view" && !(params.readInput ?? true)) {
    switch (params.inputType) {
      case "radar":
      case "radarSlider":
      case "radarRate":
        return <DataInput.RadarChart key={mergeParams.id} {...mergeParams} />;
      case "link":
        return <DataInput.Link key={mergeParams.id} {...mergeParams} />;
      case "element":
        return <DataInput.Element key={mergeParams.id} {...mergeParams} />;
      case "summary":
        return <DataInput.Summary key={mergeParams.id} {...mergeParams} />;
      case "upload":
        return <></>;
      case "qrcode":
        return <DataInput.QRCode key={mergeParams.id} {...mergeParams} />;
      default:
        return <DataInput.Display key={mergeParams.id} {...mergeParams} />;
    }
  } else {
    if (params.inputType && DatePickerTypeArray.includes(params.inputType)) {
      return <DataInput.Date key={mergeParams.id} {...mergeParams} />;
    } else {
      switch (params.inputType) {
        case "checkbox":
        case "checkboxCard":
        case "checkboxGroup":
          return <DataInput.Checkbox key={mergeParams.id} {...mergeParams} />;
        case "radio":
        case "radioButton":
        case "radioGroup":
        case "radioCard":
          return <DataInput.Radio key={mergeParams.id} {...mergeParams} />;
        //case "comboBox":
        case "segmentedControl":
          return <DataInput.Radio key={mergeParams.id} {...mergeParams} />;

        case "slider":
        case "sliderInput":
          return <DataInput.Slider key={mergeParams.id} {...mergeParams} />;
        case "rate":
        case "rateInput":
          return <DataInput.Rate key={mergeParams.id} {...mergeParams} />;

        case "select":
        case "selectSearch":
          return <DataInput.Select key={mergeParams.id} {...mergeParams} />;

        case "radar":
        case "radarSlider":
        case "radarRate":
          return <DataInput.RadarChart key={mergeParams.id} {...mergeParams} />;
        case "lineChart":
          return <DataInput.LineChart key={mergeParams.id} {...mergeParams} />;
        case "timelineChart":
          return <DataInput.TimeLineChart key={mergeParams.id} {...mergeParams} />;
        case "geoMap":
          return <DataInput.GeoMap key={mergeParams.id} {...mergeParams} />;
        case "flavorWheel":
          return <DataInput.FlavorWheel key={mergeParams.id} {...mergeParams} />;
        case "switch":
          return <DataInput.Switch key={mergeParams.id} {...mergeParams} />;
        case "switchButton":
          return <DataInput.SwitchButton key={mergeParams.id} {...mergeParams} />;
        case "summary":
          return <DataInput.Summary key={mergeParams.id} {...mergeParams} />;
        case "display":
          return <DataInput.Display key={mergeParams.id} {...mergeParams} />;
        case "image":
          return <DataInput.Image key={mergeParams.id} {...mergeParams} />;
        case "element":
          return <DataInput.Element key={mergeParams.id} {...mergeParams} />;
        case "upload":
          return <DataInput.Upload key={mergeParams.id} {...mergeParams} />;
        case "qrcode":
          return <DataInput.QRCode key={mergeParams.id} {...mergeParams} />;
        case "textArea":
        case "textField":
        case "inputSearch":
        case "link":
        case "input":
        default:
          switch (params.valueType) {
            case "boolean":
              return <DataInput.Switch key={mergeParams.id} {...mergeParams} />;
            case "number":
              return <DataInput.InputNumber key={mergeParams.id} {...mergeParams} />;
            default:
              return <DataInput.Input key={mergeParams.id} {...mergeParams} />;
          }
      }
    }
  }
};
export function GetDataValue(params: DataInputParams): JSX.Element {
  const [display, setDisplay] = useState(checkDisplay(params));
  const [inputType, setInputType] = useState(params.inputType);
  useEffect(() => {
    setInputType(params.inputType);
  }, [params.inputType]);

  const isMultipleChild = checkMultipleChild(params.inputType);
  let DataTypes;
  const checkFieldId = params.fieldId;
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setInputType"] = setInputType;
      temp_function["getDisplay"] = () => {
        return display;
      };
      temp_function["setDisplay"] = (display: boolean) => {
        // Debug(params.name, display);
        setDisplay(display);
      };
    }
  }
  if (!isMultipleChild && checkFieldId !== undefined && typeof checkFieldId !== "string" && params.inputType !== "summary") {
    const fields = Object.keys(checkFieldId);

    DataTypes = fields.map((fieldkey, field_index) => {
      const field = fieldkey + (params.index !== undefined ? "_" + params.index : "");
      const tempFiledId = checkFieldId[fieldkey];
      const subListName = getSubListValueField(fieldkey, params.subListProp);
      const mergeParam = {
        ...params,
        flexClassName: undefined,
        fieldId: field,
        subListName: subListName,
        subListOrgName: fieldkey,
        ...tempFiledId,
        ...getInputCommonParams(params.inputMode ?? "", tempFiledId),
        onChange:
          params.onChange || (tempFiledId && tempFiledId.onChange)
            ? (e: any) => {
                if (tempFiledId && tempFiledId.onChange) {
                  tempFiledId.onChange(e);
                }
                if (params.onChange) {
                  params.onChange(e);
                }
              }
            : undefined,
      };
      if (tempFiledId) {
        if (tempFiledId.fieldId !== undefined && typeof tempFiledId.fieldId !== "string") {
          return <GetDataValue key={field + "_" + field_index} {...mergeParam} />;
        } else {
          //Debug(mergeParam);
          const span = "input_ml";
          const mergeInputClass =
            field_index !== 0
              ? mergeParam.inputClassName
                ? cn(mergeParam.inputClassName, span)
                : params.inputClassName
                  ? cn(params.inputClassName, span)
                  : span
              : (mergeParam.inputClassName ?? params.inputClassName);

          //const value = ;
          const value = getMultiValue(mergeParam, getInputFieldValue(mergeParam));

          //Debug(field, params.subListTarget, params.subListName, subListName, params.index, value, params.subListData);

          const finalParam = {
            ...mergeParam,
            value: value,
            id: field,
            name: field,
            inputClassName: mergeInputClass,
          };
          // const check_display = checkDisplay(finalParam);
          // Debug(finalParam.name, finalParam.value, check_display);
          if (finalParam.display === "change" || checkDisplay(finalParam)) {
            return <GetDataValue key={field + "_" + field_index} {...finalParam} />;
          } else {
            return undefined;
          }
        }
      }
    });
  } else {
    DataTypes = GetDataType({ ...params, inputType: inputType });
  }
  if (display) {
    if (params.flexClassName) {
      return <Flex className={cn(params.flexClassName)}>{DataTypes}</Flex>;
    } else {
      return <>{DataTypes}</>;
    }
  } else {
    return <></>;
  }
  //DataTypes = GetDataType(params);
}
const checkInputAuth = (params: DataInputParams) => {};

const checkMultipleChild = (mode?: string) => {
  return mode ? ChartTypeArray.includes(mode) : false;
};
const GetDataItemCommon = (params: DataInputParams) => {
  const t = useTranslations("contents");
  const mergeParams = {
    ...params,
    ...getInputParams(params),
  };
  const [display, setDisplay] = useState(checkDisplay(mergeParams));
  const [loading, setLoading] = useState(params.loading);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const wrapped = useFlexWrapDetect(containerRef);
  useEffect(() => {
    if (params.loading !== loading) {
      setLoading(params.loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.loading]);
  if (params.formFunction && params.name && params.index !== undefined) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["getDisplay"] = () => {
        return display;
      };
      temp_function["setDisplay"] = (display: boolean) => {
        // Debug(params.name, display);
        setDisplay(display);
      };
      temp_function["getLoading"] = () => {
        return loading;
      };
      temp_function["setLoading"] = setLoading;
    }
  }

  useEffect(() => {
    const check_display = checkDisplay(mergeParams);
    if (check_display !== display) {
      setDisplay(check_display);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  if (display) {
    //const dataLabel: string | DataElement = mergeParams.label ?? (mergeParams.labelPrev ?? "") + mergeParams.name;
    const DataLabel: DataElement =
      typeof mergeParams.label === "string" || mergeParams.label === undefined
        ? { element: mergeParams.label ?? (mergeParams.labelNamePrev ?? "") + mergeParams.name }
        : mergeParams.label;
    const isMultipleChild = checkMultipleChild(mergeParams.inputType);
    if ((mergeParams.asChild ?? false) || isMultipleChild) {
      return (
        <Skeleton loading={loading}>
          {(mergeParams.labelUse ?? true) && (DataLabel.display ?? true) && !isMultipleChild ? <GetDataLabel {...mergeParams} /> : ""}
          <GetDataValue {...mergeParams} />
        </Skeleton>
      );
    } else {
      const show = checkDisplayCommon(mergeParams, true);
      const labelName = getLabelInputName(params);
      return (
        <DataList.Item
          className={cn(mergeParams.itemClassName, mergeParams.nextItemHidden ? "next-item-hidden" : "", show ? "" : "hidden")}
        >
          {(mergeParams.labelUse ?? true) && (loading || (DataLabel.display ?? true)) ? (
            <Skeleton loading={loading}>
              <DataList.Label className={cn((mergeParams.labelMyAuto ?? true) ? "md:my-auto" : "", mergeParams.labelClassName)}>
                {params.loading ? (
                  "Loading..."
                ) : labelName ? (
                  <>
                    {mergeParams.labelPrev ? GetDataInputElement(mergeParams.labelPrev, true, params.values, t) : <></>}
                    <GetDataValue
                      {...params}
                      {...params.labelInput}
                      name={labelName}
                      value={getMultiValue(params, getInputFieldValue(params, getLabelInputName(params, false)))}
                    />
                    {mergeParams.labelNext ? GetDataInputElement(mergeParams.labelNext, false, params.values, t) : <></>}
                  </>
                ) : (
                  <>
                    {mergeParams.labelPrev ? GetDataInputElement(mergeParams.labelPrev, true, params.values, t) : <></>}
                    <GetDataLabel {...mergeParams} />
                    {mergeParams.labelNext ? GetDataInputElement(mergeParams.labelNext, false, params.values, t) : <></>}
                  </>
                )}
              </DataList.Label>
            </Skeleton>
          ) : (
            <DataList.Label className="hidden">&nbsp;</DataList.Label>
          )}
          <DataList.Value
            ref={containerRef}
            className={cn(mergeParams.valueClassName, wrapped ? "isWrapped" : "notWrapped")}
            style={mergeParams.valueStyle}
          >
            {loading ? <AntSkeleton.Input active={loading} block={true} /> : <GetDataValue {...mergeParams} />}
          </DataList.Value>
        </DataList.Item>
      );
    }
  } else {
    return undefined;
  }
};

export default function GetDataItem(params: DataInputParams) {
  const [count, setCount] = useState<number | undefined>(0);
  const [subListData, setSubListData] = useState<any | undefined>(undefined);
  const [loading, setLoading] = useState(params.loading);
  const [display, setDisplay] = useState(checkDisplay(params));
  useEffect(() => {
    if (params.loading !== loading) {
      setLoading(params.loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.loading]);
  useEffect(() => {
    const check_display = checkDisplay(params);
    if (check_display != display) {
      setDisplay(check_display);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  const subListTarget = useMemo(() => {
    return params.subList !== undefined
      ? typeof params.subList === "string"
        ? typeof params.subList
        : params.subList instanceof Object
          ? params.subList.target
          : typeof params.subList === "number" || params.subList
            ? params.name
            : undefined
      : undefined;
  }, [params.subList, params.name]);

  const setSubListDataFunction = (data: any, forceConvert?: boolean) => {
    if (data) {
      if (data instanceof Array) {
        setCount(data.length);
        setSubListData(data);
        const valueConvert = forceConvert ?? (params.subList && params.subList instanceof Object ? params.subList.valueConvert : false);
        if (valueConvert) {
          const convert = convertSubListToFormData(params, data);
          Debug("setSubListDataFunction : ", params, data, convert);
          params.form?.setFieldsValue(convert);
        }
      } else {
        setCount(1);
        setSubListData(data);
      }
    } else {
      setCount(0);
      setSubListData(data);
    }
  };

  useEffect(() => {
    const sub_list_data = subListTarget
      ? (params.subValues[subListTarget] ??
        params.values[subListTarget] ??
        (params.name ? (params.values[params.name] ?? undefined) : undefined))
      : undefined;
    //const count = subListData ? (subListData instanceof Array ? subListData.length : 1) : 0;
    setSubListDataFunction(sub_list_data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.name, params.values, params.subValues, subListTarget]);

  // useEffect(() => {
  //   if (params.subList) {
  //     const count = subListData ? (subListData instanceof Array ? subListData.length : 1) : 0;
  //     setLoading(false);
  //     setCount(count);
  //   }
  // }, [params.subList, subListData]);

  const setSubListCount = (set_count?: number) => {
    let check_count = set_count;
    if (check_count !== undefined) {
      if (check_count == -1 && subListTarget) {
        check_count = subListData ? (subListData instanceof Array ? subListData.length : 1) : 0;
      }
    }
    setCount(check_count);
  };
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
  }

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["getCount"] = () => {
        return count;
      };
      temp_function["setCount"] = setSubListCount;
      temp_function["getSubListData"] = () => {
        return subListData;
      };
      temp_function["setSubListData"] = setSubListDataFunction;
      temp_function["getItemDisplay"] = () => {
        return display;
      };
      temp_function["setItemDisplay"] = (display: boolean) => {
        // Debug(params.name, display);
        setDisplay(display);
      };
      temp_function["getLoading"] = () => {
        return loading;
      };
      temp_function["setLoading"] = setLoading;
    }
  }

  if (!display) {
    return undefined;
  } else {
    const params_name = params.name ?? "";
    if (params.subList && count !== undefined) {
      if (params.formMemo) {
        if (!params.formMemo[params_name]) {
          params.formMemo[params_name] = {};
        }
        params.formMemo[params_name].subList = params.subList;
        params.formMemo[params_name].subListCount = count;
      }
      const field_list = [];
      const valueField = getSubListValueField(params.name, params.subList);
      if (count === 0 && (params.subListEmptyValue !== undefined || params.subListEmptyLabel !== undefined)) {
        const value = params.subListEmptyValue;
        const label = params.subListEmptyLabel;
        const labelUse = params.subListEmptyLabel === "empty" ? false : true;
        return (
          <GetDataItemCommon
            key={params_name}
            {...params}
            name={params_name}
            id={params.id}
            labelUse={labelUse}
            loading={loading}
            subList={undefined}
            label={label ?? params.label ?? params.name}
            valueStyle={labelUse ? params.valueStyle : { ...params.valueStyle, gridColumn: "1 / span 2" }}
            fieldId={value === undefined ? params.fieldId : undefined}
            value={loading ? "" : value}
          />
        );
      }
      for (let i = 0; i < count; i++) {
        field_list.push(params_name + "_" + i);
      }
      //Debug(subListData);
      return (
        <>
          {field_list.map((field_name, i) => {
            const value = getMultiValue(params, getInputFieldValue(params, valueField));
            // setTimeout(
            //   () => {
            //     if (params.form?.getFieldInstance(field_name)) {
            //       params.form.setFieldValue(field_name, value);
            //     }
            //   },
            //   i * 3 + 50,
            // );
            return (
              <GetDataItemCommon
                key={field_name}
                {...params}
                name={params_name + "_" + i}
                id={params.id + "_" + i}
                value={loading ? "" : value}
                index={i}
                loading={loading}
                subList={undefined}
                subListTarget={subListTarget}
                subListName={valueField}
                subListOrgName={params_name}
                subListData={subListData}
                subListProp={params.subList}
                display={undefined}
                //label={params.label ?? params.name}
              />
            );
          })}
        </>
      );
    } else {
      return <GetDataItemCommon {...params} />;
    }
  }
}
